import { LegacyAnchor } from '@common*';
import { Center, Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

const TRANS_KEY = 'FOOTER';

export const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Center className={styles.footerRoot}>
      <Group gap="sm">
        <Text>{t(`${TRANS_KEY}.COPYRIGHT`)}</Text>
        <Text>|</Text>
        <Text>
          <LegacyAnchor href="/impressum">
            {t(`${TRANS_KEY}.IMPRESSUM`)}
          </LegacyAnchor>
          {/* TODO: Replace LegacyAnchor with Link when we have the new impressum page */}

          {/* <Link className={styles.footerLink} to="/impressum">
            {t(`${TRANS_KEY}.IMPRESSUM`)}
          </Link> */}
        </Text>
        <Text>|</Text>
        <Text>{t(`${TRANS_KEY}.VERSION`, { version: __APP_VERSION__ })}</Text>
      </Group>
    </Center>
  );
};
